import {connect, useSelector} from "react-redux";
import React, {useCallback, useEffect, useMemo, useRef, useState} from "react";
import {Loading} from "../../../components/common";
import StoreListWhere from "../where/StoreListWhere";
import {CAlert, CButton, CCol, CForm, CFormSelect, CInputGroup, CInputGroupText, CRow} from "@coreui/react";
import * as o2Api from "../../../api/api";
import {AgGridReact} from "ag-grid-react";
import {itemTypeFormatter} from "../../../config/formatter";
import StoreCornerListWhere from "../where/StoreCornerListWhere";

const StoreConfig = (props) => {
	const {user} = useSelector((props) => props.account);
	const containerStyle = useMemo(() => ({width: "100%", height: "100%"}), []);
	const {cmpCd, brandCd, storeCd} = props.selected;
	const headerGridRef = useRef();
	const gridRef = useRef();
	const [pos, setPos] = useState([{deviceId: "전체"}]);
	const [loading, setLoading] = useState(false);
	const [error, setError] = useState({
		visible: false,
		message: ""
	});
	const [searchForm, setSearchForm] = useState({});
	const [headerData, setHeaderData] = useState([]);
	const [detailData, setDetailData] = useState([]);

	const defaultColDef = {
		flex: 1,
		resizable: true,
		sortable: true,
		filter: false,
		autoHeaderHeight: true,
		editable: true,
		cellEditor: 'agTextCellEditor',
	};

	const [headerDefs] = useState([
		{field: "mainFormNm", headerName: "메인", minWidth: 100, cellClass: "static-cell"},
		{field: "subFormNm", headerName: "하위"}
	]);

	const [detailDefs] = useState([
		{field: "configNm", headerName: "세부항목", maxWidth: 150},
		{
			field: "value", headerName: "입력값", minWidth: 100, cellRendererFramework: itemTypeFormatter,
			editable: (e) => {
				return e.data.itemType === "Text";
			},
			singleClickEdit: true,
			cellEditor: 'agTextCellEditor',
			cellRendererParams: {
				onEventChange: (rowIndex, rowData) => {
					console.log("###### data :: ", detailData);

					// api 에서 이전 grid 데이터를 꺼내온다
					const data = [];
					const {api} = gridRef.current;
					api.forEachNode(function (rowNode, index) {
						data.push(rowNode.data);
					});

					setDetailData(
						data.map((item, idx) => (idx === rowIndex ? rowData : item))
					)
				}
			}
		},
		{field: "explanation", headerName: "설명", minWidth: 200},
	]);

	useEffect(() => {
		if (props.selected.storeCd.length > 0) {
			getStoreDevice();
		}
	}, [props.selected.storeCd]);

	const getStoreDevice = () => {
		const {cmpCd, brandCd, storeCd} = props.selected;
		const params = {
			cmpCd: cmpCd,
			brandCd: brandCd,
			storeCd: storeCd,
			useYn: "Y",
			versionCd: "000000"
		}
		setLoading(true);
		o2Api.getStoreDevice(params).then((result) => {
			const {responseBody, responseCode, responseMessage} = result.data;
			if (responseCode === "200") {
				// 성공
				setPos([{deviceId: "전체"}]);
				setPos((state) => state.concat(responseBody));

				setLoading(false);
			}
		});
	};

	const handleSelect = (code, value) => {
		if (value === "C") {
			setSearchForm((state) => ({
				...state,
				cmpCd: code
			}));
		} else if (value === "B") {
			setSearchForm((state) => ({
				...state,
				brandCd: code
			}));
		} else if (value === "S") {
			setSearchForm((state) => ({
				...state,
				storeCd: code
			}));
		} else if (value === "O") {
			setSearchForm((state) => ({
				...state,
				cornerCd: code
			}));
		}
	};

	const search = () => {
		setError({
			visible: false,
			message: ""
		});

		const {cmpCd, brandCd, storeCd} = props.selected;
		if (brandCd.length === 0) {
			setError({
				visible: true,
				message: "조회시 휴게소는 반드시 선택하셔야 합니다."
			});
			return;
		}

		if (storeCd.length === 0) {
			setError({
				visible: true,
				message: "조회시 매장은 반드시 선택하셔야 합니다."
			});
			return;
		}

		if (searchForm.deviceId === '전체') {
			setError({
				visible: true,
				message: "조회시 POS번호는 반드시 선댁하셔야 합니다."
			});
			return;
		}

		const params = {
			posType: '0',
			posCd: searchForm.deviceId,
			versionCd: "000000"
		};
		console.log(">>> params :: ", searchForm);

		setLoading(true);
		o2Api.getPosConfig(params).then((result) => {
			const {responseBody, responseCode, responseMessage} = result.data;
			if (responseCode === "200") {
				setLoading(false);

				headerGridRef.current.api.deselectAll();
				setHeaderData(responseBody);

				setDetailData([]);
			}
		});
	};

	const detail = (form) => {
		setError({
			visible: false,
			message: ""
		});

		const {cmpCd, brandCd, storeCd} = props.selected;
		const params = {
			cmpCd: cmpCd,
			brandCd: brandCd,
			storeCd: storeCd,
			posCd: searchForm.deviceId,
			mainFormCd: form.mainFormCd,
			subFormCd: form.subFormCd,
			posType: '0'
		};

		setLoading(true);
		o2Api.getPosConfigData(params).then((result) => {
			const {responseBody, responseCode, responseMessage} = result.data;
			if (responseCode === "200") {
				getCommonCodeGroup(responseBody);
			}
		})
	}

	const getCommonCodeGroup = async (data) => {
		// 하위 CommonCode 선택 데이터를 가져온다
		const commonCodeGroupDataList = [];

		for (let item of data) {
			let responseItem = item;
			if (item.commGrpCd !== null) {
				const params = {
					groupCode: item.commGrpCd
				}

				console.log(">>> params :: ", params);

				await o2Api.getCommonCodeGroup(params)
					.then((result) => {
						const body = result.data.responseBody;
						responseItem = {
							...responseItem,
							selectValues: body
						}
					})
					.catch((error) => {

					})
					.finally(() => {
						commonCodeGroupDataList.push(responseItem);
					})
			}
			else {
				commonCodeGroupDataList.push(responseItem);
			}
		}
		setLoading(false);
		setDetailData(commonCodeGroupDataList);

		console.log("### groupList :: ", commonCodeGroupDataList);
	}

	const onRowClicked = useCallback((e) => {
		if (!e.node.selected) return;
		detail(e.data);
	}, [searchForm]);

	const save = () => {
		if(confirm("저장하시겠습니까?")) {
			const {cmpCd, brandCd, storeCd} = props.selected;

			const {api} = gridRef.current;
			api.stopEditing();

			setTimeout(() => {
				const configs = [];
				api.forEachNode((obj, idx) => {
					obj.data.cmpCd = cmpCd;
					obj.data.brandCd = brandCd;
					obj.data.storeCd = storeCd;
					obj.data.posCd = searchForm.deviceId;

					if (obj.data.itemType === "Radio" || obj.data.itemType === "Combo" || obj.data.itemType === "Checkbox")   {
						obj.data.value = obj.data.value ? obj.data.value : obj.data.selectValues[0].subCode
					}
					configs.push(obj.data);
				})

				console.log(">>> params :: ", configs);
				setLoading(true);
				o2Api.mergePosConfig(configs).then((result) => {
					const {responseBody, responseCode, responseMessage} = result.data;
					if (responseCode === "200") {
						// 성공
						console.log("###### SUCCESS ");
						// search();
					}
				})
					.finally(() => {
						setLoading(false);
					})
			}, 200);
		}
	}

	return (
		<>
			<div style={containerStyle}>
				{loading ? <Loading/> : null}
				{error.visible ? <CAlert color="danger" dismissible={true}>{error.message}</CAlert> : null}
				<div className="d-grid gap-1 d-md-flex justify-content-between" style={{marginBottom: 10}}>
					<h5>환경설정</h5>
					<div>
						<CButton size={"sm"} color="dark" onClick={search}>조회</CButton>
						<CButton style={{marginLeft: 10}} size={"sm"} color="dark" onClick={save}>저장</CButton>
					</div>
				</div>
				<CForm className={"row row-cols-lg-auto g-1 align-items-center"}>
					<StoreCornerListWhere type={"S"} account={props.account} selected={searchForm}
									onSelect={(c, v) => handleSelect(c, v)}/>
					<CCol xs={12}>
						<CInputGroup size="sm">
							<CInputGroupText style={{width: 100}}>POS번호</CInputGroupText>
							<CFormSelect value={searchForm.deviceId}
										 onChange={(e) => {
											 setSearchForm((state) => ({
												 ...state,
												 deviceId: e.target.value
											 }));
										 }}
							>
								{pos.map((p, index) => {
									return (
										<option key={index} value={p.deviceId}>{p.deviceId}</option>
									);
								})}
							</CFormSelect>
						</CInputGroup>
					</CCol>
				</CForm>
				<div style={{height: 10}}/>
				<CRow>
					<CCol xs={4}>
						<div style={{borderRadius: 5, padding: 10, marginBottom: 10, background: "#87CEFA"}}>
							환경설정 항목
						</div>
						<div className="ag-theme-alpine" style={{width: "100%", height: 550, marginTop: 10}}>
							<AgGridReact
								ref={headerGridRef}
								rowSelection={"single"}
								headerHeight={35}
								rowHeight={35}
								rowData={headerData}
								animateRows={true}
								localeText={{noRowsToShow: "조회 결과가 없습니다."}}
								onRowSelected={onRowClicked}
								defaultColDef={defaultColDef}
								columnDefs={headerDefs}>
							</AgGridReact>
						</div>
					</CCol>
					<CCol>
						<div style={{borderRadius: 5, padding: 10, marginBottom: 10, background: "#87CEFA"}}>
							환경설정 세부항목
						</div>
						<div className="ag-theme-alpine" style={{width: "100%", height: 550, marginTop: 10}}>
							<AgGridReact
								ref={gridRef}
								headerHeight={35}
								rowHeight={35}
								rowData={detailData}
								animateRows={true}
								suppressScrollOnNewData={true}
								localeText={{noRowsToShow: "조회 결과가 없습니다."}}
								defaultColDef={defaultColDef}
								columnDefs={detailDefs}>
							</AgGridReact>
						</div>
					</CCol>
				</CRow>
			</div>
		</>
	);
};

const mapStateToProps = (state) => {
	const {account, store, selected} = state;
	return {
		account, store, selected
	}
}

export default connect(mapStateToProps, null)(StoreConfig);
